import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {baseUrl, tokenKey} from "./authProvider";
import "./ApproveButton.scss";
import DefaultNoImage from "./assets/default-attachment.png";

class SpecialOptionCustomInput extends Component {
  state = {
    rank: "member",
    title: "",
    content: "",
    icon: "",
    preview: ""
  };

  generateHeaders = () => {
    const token = localStorage.getItem(tokenKey);
    return {
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    };
  };

  submit = () => {
    let form_data = new FormData();
    form_data.append("rank", this.state.rank);
    form_data.append("title", this.state.title);
    form_data.append("content", this.state.content);
    form_data.append("image", this.state.icon);
    axios
    .post(baseUrl + "/special-option", form_data, {
      headers: this.generateHeaders()
    })
    .then(response => {
      alert("Create option successfully");
      let link = window.location.href.replace("create", response.data.data.id);
      window.location.href = link;
    }).catch(error => {
      alert(error.response.data.message)
    })
  };

  handleImageChange = e => {
    let file = URL.createObjectURL(e.target.files[0]);
    this.setState({
      preview: file,
      icon: e.target.files[0]
    });
  };

  handleChange = event => {
    let name = event.target.name;
    this.setState({
      [name]: event.target.value
    });
  };

  render() {
    return (
      <div className="form-group">
        <Fragment>
          <div>
            <div>Rank:</div>
            <select name="rank" onChange={this.handleChange} className="form-control">
              <option value="member">Member</option>
              <option value="gold">Gold</option>
              <option value="platinum">Platinum</option>
            </select>
          </div>
          <div>
            <div>Title:</div>
            <input
              type="text"
              className="form-control"
              name="title"
              onChange={this.handleChange}
            />
          </div>
          <div>
            <div>Content:</div>
            <input
              type="text"
              className="form-control"
              name="content"
              onChange={this.handleChange}
            />
          </div>
          <div className="attachment-photo">
            <div>
              <div className="ChangePhotoText">Update icon</div>
              <input
                type="file"
                accept="image/*"
                name="icon"
                onChange={this.handleImageChange}
              />
            </div>
            <img
              className="Photo"
              alt="attachment"
              src={this.state.preview ? this.state.preview : DefaultNoImage}
            />

          </div>
          <div className="action-button">
            <input
              type="button"
              className="accept-button"
              onClick={this.submit}
              value="Submit"
            />
          </div>
        </Fragment>
      </div>
    );
  }
}

export default connect(
  null,
  {}
)(SpecialOptionCustomInput);
